import { DialogTitle, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { palette, surface } from "@/theme";

export const ModalTitle = styled(DialogTitle)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: `${surface.padding} ${surface.padding} 0`,
  ...theme.typography.h4,
  fontWeight: theme.typography.fontWeightMedium,
  color: palette.neutral[90],
  [theme.breakpoints.down("md")]: {
    padding: `${surface.paddingCompact} ${surface.paddingCompact} 0`,
  },
}));

export const ModalTitleText = styled("span")(({ theme }) => ({
  display: "block",
  ...theme.typography.h4,
  fontWeight: theme.typography.fontWeightMedium,
  color: palette.neutral[90],
}));

export const ModalTitleCloseButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  color: palette.neutral[60],
  "&:hover": {
    backgroundColor: palette.neutral[5],
    color: palette.neutral[90],
  },
}));
